import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import { SchoolRulesClient } from '../components/SchoolRulesClient'
import { prefetchSchoolPolicies } from '../lib/route-prefetch'

function SchoolRulesError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load rules.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/school/$schoolId/rules/')({
  head: () => ({
    meta: [{ title: 'School Rules | Unbreakable' }],
  }),
  beforeLoad: ({ context, params }) => {
    prefetchSchoolPolicies(context.queryClient, params.schoolId)
  },
  errorComponent: SchoolRulesError,
  component: SchoolRulesPage,
})

function SchoolRulesPage() {
  return <SchoolRulesClient />
}
